import {formatter, request} from '@/utils/request';

export namespace Accrual {
  const Path = {
    QueryServicesForAccrual: "/taskapi/accrual/queryServicesForAccrual",
    SearchAllowAccrual: "/taskapi/accrual/searchAllowAccrual",
    NextAccrualYM: "/taskapi/accrual/nextAccrualYm",
    CurrentAccrualYM: "/taskapi/accrual/currentAccrualYm",
    AccrualSimulate: '/taskapi/accrual/accrualSimulate',
    AccrualValidate: '/taskapi/accrual/accrualValidate',
    SearchAllowAccrualExport: "/taskapi/accrual/searchAllowAccrualExport",
    QueryServicesForForecastAccrual: '/taskapi/accrual/queryServicesForForecastAccrual',
  }

  export async function queryServicesForAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.ServiceQuery>>(Path.QueryServicesForAccrual, formatter(options));
  }

  export async function searchAllowAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.AccrualValidateResult>>(Path.SearchAllowAccrual, formatter(options));
  }

  export async function nextAccrualYm(boHqId: number) {
    const options = {
      method: 'GET',
      body: {
        boHqId: boHqId
      }
    };
    return request<API.ResponseResult<any>>(Path.NextAccrualYM, formatter(options));
  }

  export async function currentAccrualYm(boHqId: number) {
    const options = {
      method: 'GET',
      body: {
        boHqId: boHqId
      }
    };
    return request<API.ResponseResult<any>>(Path.CurrentAccrualYM, formatter(options));
  }

  export async function accrualSimulate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<boolean>>(Path.AccrualSimulate, formatter(options));
  }

  export async function accrualValidate(boHqId: number, ym: number) {
    const options = {
      method: 'GET',
      body: {
        boHqId: boHqId,
        ym: ym
      }
    };
    return request<API.ResponseResult<any>>(Path.AccrualValidate, formatter(options));
  }

  export async function searchAllowAccrualExport(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.AccrualValidateResult>>(Path.SearchAllowAccrualExport, formatter(options));
  }

  export async function queryServicesForForecastAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.ServiceQuery>>(Path.QueryServicesForForecastAccrual, formatter(options));
  }
}
